import { useRouter } from '@/hooks/useRouter';
import { axios } from '@/plugins/axios';
import vueRouter from '@/router';
import { useNotification } from '@/shared/hooks/useNotification';
import { useTitle } from '@/shared/hooks/useTitle';
import { endPoints } from '@/shared/types/api';
import { useStore } from '@/store';
import { queryToString } from '@/utils/query';
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  SetupContext,
} from '@vue/composition-api';
import { Dialog, Typography } from '../../parts';

export type ReactiveData = {
  password: string;
  confirmPassword: string;
};

export default defineComponent({
  components: { Typography, Dialog },
  setup(_, ctx: SetupContext) {
    const router = useRouter();
    const name = [router.currentRoute.query.name].flat();

    const { showNotification } = useNotification();

    const organizationIds = queryToString(ctx.root.$route.params.id);

    const store = useStore();
    const { setTitle } = useTitle();

    const state = reactive<ReactiveData>({
      password: '',
      confirmPassword: '',
    });

    onMounted(() => {
      setTitle({
        title: 'ログインパスワード変更',
        icon: 'mdi-square-edit-outline',
      });
    });

    const changePassword = async () => {
      if (state.password !== state.confirmPassword) {
        return showNotification({
          isShow: true,
          message: 'パスワードが一致していません',
          type: 'error',
        });
      } else {
        return await axios.post(endPoints.savePassword.endPoint, {
          organization_ids: organizationIds,
          password: state.password,
        });
      }
    };

    const back = () => {
      vueRouter.back();
    };

    const min = computed(() => store.getters.validation.password_length_min);
    const max = computed(() => store.getters.validation.password_length_max);

    return {
      state,
      changePassword,
      disabled: computed(() => {
        return (
          state.password.length < min.value ||
          state.confirmPassword.length < min.value ||
          state.password.length > max.value ||
          state.confirmPassword.length > max.value ||
          state.password !== state.confirmPassword
        );
      }),
      back,
      min,
      max,
      name,
    };
  },
});
